import { render } from "./BackgroundPattern.vue?vue&type=template&id=5c8eadf2&ts=true"
import script from "./BackgroundPattern.vue?vue&type=script&lang=ts"
export * from "./BackgroundPattern.vue?vue&type=script&lang=ts"

import "./BackgroundPattern.vue?vue&type=style&index=0&id=5c8eadf2&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__